/*
 * Wishlist Parfumelo.
 *
 * Nu foloseste nicio aplicatie si nicio biblioteca externa. Lista traieste in
 * localStorage, deci este per-dispozitiv: nu se sincronizeaza intre telefon si
 * laptop si nu ajunge la Shopify.
 *
 * Butoanele sunt injectate din JS, nu din liquid, pentru ca Horizon reincarca
 * sectiuni dinamic (filtrare, paginare, quick add) si ar sterge marcajul static.
 */
(function () {
  'use strict';

  var CHEIE = 'parfumelo:wishlist:v1';
  var ETICHETA_ADAUGA = 'Adaugă la favorite';
  var ETICHETA_SCOATE = 'Scoate de la favorite';

  /* ---------- stocare ---------- */

  function citeste() {
    try {
      var brut = window.localStorage.getItem(CHEIE);
      var lista = brut ? JSON.parse(brut) : [];
      return Array.isArray(lista) ? lista.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      // mod privat, cookie-uri blocate, cota depasita
      return [];
    }
  }

  function scrie(lista) {
    try {
      window.localStorage.setItem(CHEIE, JSON.stringify(lista));
    } catch (e) {
      /* nu putem persista; interfata ramane corecta pentru sesiunea curenta */
    }
    document.dispatchEvent(new CustomEvent('parfumelo:wishlist', { detail: { lista: lista } }));
  }

  function contine(handle) { return citeste().indexOf(handle) !== -1; }

  function comuta(handle) {
    var lista = citeste();
    var i = lista.indexOf(handle);
    if (i === -1) lista.push(handle); else lista.splice(i, 1);
    scrie(lista);
    return i === -1;
  }

  function scoate(handle) {
    var lista = citeste();
    var i = lista.indexOf(handle);
    if (i !== -1) { lista.splice(i, 1); scrie(lista); }
  }

  /* ---------- utilitare ---------- */

  function handleDinUrl(url) {
    if (!url) return null;
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function inima() {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M12 20.5 4.4 13a4.6 4.6 0 0 1 0-6.5 4.6 4.6 0 0 1 6.5 0l1.1 1.1 1.1-1.1a4.6 4.6 0 0 1 6.5 0 4.6 4.6 0 0 1 0 6.5Z"/>' +
      '</svg>'
    );
  }

  function pret(bani) {
    var v = (bani / 100).toFixed(2);
    return v + ' MDL';
  }

  /* ---------- butoane ---------- */

  function faButon(handle, clasa, cuEticheta) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pw-btn ' + clasa;
    b.dataset.pwHandle = handle;
    b.innerHTML = inima() + (cuEticheta ? '<span class="pw-label"></span>' : '');
    actualizeazaButon(b);
    b.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      comuta(handle);
    });
    return b;
  }

  function actualizeazaButon(b) {
    var activ = contine(b.dataset.pwHandle);
    b.setAttribute('aria-pressed', activ ? 'true' : 'false');
    var eticheta = activ ? ETICHETA_SCOATE : ETICHETA_ADAUGA;
    b.setAttribute('aria-label', eticheta);
    b.setAttribute('title', eticheta);
    var span = b.querySelector('.pw-label');
    if (span) span.textContent = activ ? 'Salvat la favorite' : ETICHETA_ADAUGA;
  }

  /* ---------- injectare ---------- */

  function pregatesteCarduri(radacina) {
    var carduri = (radacina || document).querySelectorAll('product-card:not([data-pw-gata])');
    Array.prototype.forEach.call(carduri, function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      var handle = handleDinUrl(link && link.getAttribute('href'));
      if (!handle) return;
      card.dataset.pwGata = '1';
      card.appendChild(faButon(handle, 'pw-btn--card', false));
    });
  }

  function pregatestePaginaProdus() {
    if (document.querySelector('.pw-btn--product')) return;
    var handle = handleDinUrl(window.location.pathname);
    if (!handle) return;
    var atc = document.querySelector('add-to-cart-component');
    if (!atc) return;
    var gazda = atc.closest('span') || atc;
    var b = faButon(handle, 'pw-btn--product', true);
    gazda.parentNode.insertBefore(b, gazda.nextSibling);
  }

  function pregatesteHeader() {
    if (document.querySelector('.pw-header-link')) return;
    // Horizon nu are un container ".header-actions"; iconitele din dreapta stau
    // direct in .header__column--right. Ne asezam inaintea butonului de cont.
    var cont = document.querySelector('.header__column--right .account-button');
    var cos = document.querySelector('.header__column--right .header-actions__cart-icon');
    var ancora = cont || (cos && cos.parentElement === (cont || {}).parentElement ? cos : cos);
    var gazda = ancora ? ancora.parentElement : document.querySelector('.header__column--right');
    if (!gazda) return;

    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'header-actions__action pw-header-link';
    a.setAttribute('aria-label', 'Favorite');
    a.innerHTML =
      '<span class="svg-wrapper">' + inima() +
      '</span><span class="pw-count" aria-hidden="true" hidden>0</span>';
    var svg = a.querySelector('svg');
    svg.style.width = '20px';
    svg.style.height = '20px';

    if (ancora && ancora.parentElement === gazda) gazda.insertBefore(a, ancora);
    else gazda.appendChild(a);
  }

  /* ---------- pagina de favorite ---------- */

  function randeazaPagina() {
    var gazda = document.getElementById('pw-page');
    if (!gazda) return;
    var lista = citeste();

    if (!lista.length) {
      gazda.innerHTML =
        '<div class="pw-empty">' +
        '<p>Nu ai niciun parfum salvat.</p>' +
        '<a class="button" href="/collections/all">Vezi parfumurile</a>' +
        '</div>';
      return;
    }

    gazda.innerHTML = '<div class="pw-grid"></div>';
    var grila = gazda.querySelector('.pw-grid');

    lista.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (p) {
          var el = document.createElement('article');
          el.className = 'pw-item';
          var poza = p.featured_image
            ? '<img src="' + p.featured_image + '&width=500" alt="" loading="lazy">'
            : '';
          // prima varianta disponibila; daca produsul e epuizat, butonul se dezactiveaza
          var varianta = null;
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].available) { varianta = p.variants[i]; break; }
          }
          el.innerHTML =
            '<a class="pw-item__media" href="' + p.url + '">' + poza + '</a>' +
            '<a class="pw-item__title" href="' + p.url + '"></a>' +
            '<span class="pw-item__price">' + pret(p.price) + '</span>' +
            '<button type="button" class="pw-item__add pf-btn pf-btn--plin"></button>' +
            '<button type="button" class="pw-item__remove" aria-label="Scoate de la favorite">&times;</button>';
          el.querySelector('.pw-item__title').textContent = p.title;

          var add = el.querySelector('.pw-item__add');
          if (varianta) {
            add.textContent = 'Adaugă în coș';
            add.addEventListener('click', function () {
              add.disabled = true;
              add.textContent = 'Se adaugă…';
              var cere = window.ParfumeloCos
                ? window.ParfumeloCos.adauga(varianta.id)
                : Promise.resolve(false);
              cere.then(function (ok) {
                add.textContent = ok ? 'Adăugat în coș' : 'Nu s-a putut adăuga';
                if (!ok) add.disabled = false;
              });
            });
          } else {
            add.textContent = 'Stoc epuizat';
            add.disabled = true;
          }

          el.querySelector('.pw-item__remove').addEventListener('click', function () {
            scoate(handle);
            el.remove();
            if (!citeste().length) randeazaPagina();
          });
          grila.appendChild(el);
        })
        .catch(function () {
          // produs sters sau nedisponibil: il scoatem tacut din lista
          scoate(handle);
        });
    });
  }

  /* ---------- sincronizare ---------- */

  function sincronizeaza() {
    Array.prototype.forEach.call(document.querySelectorAll('.pw-btn'), actualizeazaButon);
    var n = citeste().length;
    var c = document.querySelector('.pw-count');
    if (c) {
      c.textContent = String(n);
      c.hidden = n === 0;
    }
    // cifra din bulina e decorativa; cititorul de ecran are nevoie de text
    var link = document.querySelector('.pw-header-link');
    if (link) {
      link.setAttribute(
        'aria-label',
        n === 0 ? 'Favoritele mele, gol'
                : 'Favoritele mele, ' + n + (n === 1 ? ' produs' : ' produse')
      );
    }
  }

  function porneste() {
    pregatesteHeader();
    pregatesteCarduri(document);
    pregatestePaginaProdus();
    randeazaPagina();
    sincronizeaza();
  }

  document.addEventListener('parfumelo:wishlist', sincronizeaza);
  // alt tab al aceluiasi browser
  window.addEventListener('storage', function (e) { if (e.key === CHEIE) porneste(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }

  // Horizon randeaza sectiuni din nou dupa filtrare, paginare sau quick add.
  //
  // Observatorul trebuie oprit cat timp lucram: injectarea butoanelor si
  // actualizarea contorului sunt ele insele mutatii, si fara pauza s-ar
  // rechema la nesfarsit. Amanam si intr-un timer, ca sa nu rulam de zeci de
  // ori pentru o singura re-randare.
  var obs = new MutationObserver(programeaza);
  var asteapta = null;

  function porneste_observator() {
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function programeaza() {
    if (asteapta) return;
    asteapta = window.setTimeout(function () {
      asteapta = null;
      obs.disconnect();
      try {
        pregatesteHeader();
        pregatesteCarduri(document);
        pregatestePaginaProdus();
        sincronizeaza();
      } finally {
        porneste_observator();
      }
    }, 120);
  }

  porneste_observator();

  window.ParfumeloWishlist = { citeste: citeste, comuta: comuta, scoate: scoate };
})();
